import * as FA from '@fortawesome/pro-solid-svg-icons';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import React, {Component} from 'react';
import Draggable, {DraggableData} from 'react-draggable';
import ReactTooltip from 'react-tooltip';

import {PlayerProps} from './properties';

import styles from './Toolbar.module.css'

interface ToolbarProps {
    // Global player properties
    playerProps: PlayerProps;

    onChangeZoom?: (value: number) => void;
    onCenter?: () => void;
    onPlaySelection?: () => void;
}

interface ToolbarState {
    maxZoom: number;
    x: number;
}

export class Toolbar extends Component<ToolbarProps, ToolbarState> {
    private container: HTMLDivElement | null = null;
    private containerCheckInterval: number = 0;
    private cursorElm: Draggable | null;
    private dragTimer = 0;
    private lastContainerWidth: number = 0;
    private sliderElm: HTMLElement | null;
    private sliderTrackActiveElm: HTMLElement | null;
    private tooltipId = '';
    private zoom = 1;

    public constructor(props: ToolbarProps) {
        super(props);
        this.state = {
            maxZoom: 1,
            x: 0,
        };
        this.tooltipId = `zoomTooltip_${Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)}`;
    }


    public componentDidMount() {
        if (this.containerCheckInterval !== 0) {
            window.clearInterval(this.containerCheckInterval);
            this.containerCheckInterval = 0;
        }
        if (this.container === null) {
            return;
        }
        this.lastContainerWidth = this.container.getBoundingClientRect().width;
        this.recomputeMaxZoom(this.lastContainerWidth);
        this.setState({...this.state, maxZoom: this.recomputeMaxZoom(this.lastContainerWidth)});
        this.containerCheckInterval = window.setInterval(
            () => {
                if (this.container === null) {
                    return;
                }
                const viewport = this.container.getBoundingClientRect().width;
                if (this.lastContainerWidth !== viewport) {
                    this.setState({...this.state, maxZoom: this.recomputeMaxZoom(viewport)});
                }
                this.lastContainerWidth = viewport;
            },
            1000,
        );
        if (typeof this.props.playerProps.initialZoom !== 'undefined') {
            window.setTimeout(
                () => {
                    if (
                        (typeof this.props.playerProps.initialZoom === 'undefined') ||
                        (this.props.playerProps.initialZoom <= 0) ||
                        (this.container === null)
                    ) {
                        return;
                    }
                    this.setZoom(
                        ((this.props.playerProps.initialZoom >= 1) ? 1 : this.props.playerProps.initialZoom),
                        true,
                    );
                },
                1000,
            );
        }
    }

    public componentWillUnmount() {
        if (this.containerCheckInterval !== 0) {
            window.clearInterval(this.containerCheckInterval);
            this.containerCheckInterval = 0;
        }
        this.lastContainerWidth = 0;
    }

    public render() {
        return <div className={styles.container} ref={(e) => {this.container = e;}}>
            <div className={styles.firstLine}>
                <div className={styles.left}>
                    {
                        (
                            (typeof this.props.playerProps.selectionStart !== 'undefined') &&
                            (typeof this.props.playerProps.selectionEnd !== 'undefined')
                        ) ?
                            <a
                                className={styles.button + ' ' + styles.buttonPlaySelection}
                                onClick={() => {
                                    if (typeof this.props.onPlaySelection !== 'undefined') {
                                        this.props.onPlaySelection();
                                    }
                                }}
                                title='Rejouer la sélection'
                            >
                                <FontAwesomeIcon icon={FA.faPlay} />
                            </a> : ''
                    }
                    <a
                        className={styles.button + ' ' + styles.buttonCenterCursor}
                        onClick={() => {
                            if (typeof this.props.onCenter !== 'undefined') {
                                this.props.onCenter();
                            }
                        }}
                        title='Centrer sur le curseur'
                    >
                        <FontAwesomeIcon icon={FA.faLocation} />
                    </a>
                    <a
                        className={styles.button + ' ' + styles.buttonZoomOut}
                        onClick={this.zoomOut.bind(this)}
                        title='Dézoomer (shift pour zoom rapide)'
                    >
                        <FontAwesomeIcon icon={FA.faSearchMinus} />
                    </a>
                    <a
                        className={styles.button + ' ' + styles.buttonZoomIn}
                        onClick={this.zoomIn.bind(this)}
                        title='Zoomer (shift pour zoom rapide)'
                    >
                        <FontAwesomeIcon icon={FA.faSearchPlus} />
                    </a>
                </div>
                <div className={styles.center}>
                    <div
                        className={styles.slider}
                        onClick={this.onSliderClick.bind(this)}
                        ref={ref => this.sliderElm = ref}
                    >
                        <div className={styles.sliderTrack} />
                        <div
                            className={styles.sliderTrackActive}
                            ref={ref => this.sliderTrackActiveElm = ref}
                        />
                        <Draggable
                            axis='x'
                            bounds='parent'
                            defaultPosition={{x: 0, y: 0}}
                            grid={[1, 1]}
                            handle={`#handle_${this.tooltipId}`}
                            ref={ref => this.cursorElm = ref}
                            scale={1}

                            onDrag={this.onDragZoom.bind(this)}
                        >
                            <div
                                className={styles.sliderCursor}
                                data-for={this.tooltipId}
                                data-tip=''
                                id={`handle_${this.tooltipId}`}
                            />
                        </Draggable>
                        <ReactTooltip
                            id={this.tooltipId}
                            getContent={() => `${this.zoom}x`}
                        />
                    </div>
                </div>
            </div>
            <div className={styles.secondLine}>
                b
            </div>
        </div>;
    }

    private setZoom(value: number, updateCursor: boolean): void {
        value = (value < 0) ? 0 : ((value > 1) ? 1 : value);
        const percent = value * 100;
        this.setState({...this.state, x: value});
        value = Math.round((Math.exp(Math.log(this.state.maxZoom) * value)));

        if (value === this.zoom) {
            return;
        }
        this.zoom = value;
        if (this.dragTimer !== 0) {
            window.clearTimeout(this.dragTimer);
            this.dragTimer = 0;
        }
        if (typeof this.props.onChangeZoom !== 'undefined') {
            this.dragTimer = window.setTimeout(
                () => {
                    if (typeof this.props.onChangeZoom !== 'undefined') {
                        this.props.onChangeZoom(value);
                    }
                },
                250,
            );
        }
        if (
            (this.sliderElm !== null) &&
            (this.cursorElm !== null)
        ) {
            if (updateCursor) {
                const box = this.sliderElm.getBoundingClientRect();
                const x = Math.round((box.width - 10) * (percent / 100));

                this.cursorElm.setState({...this.cursorElm.state, x});
            }
            if (this.sliderTrackActiveElm !== null) {
                this.sliderTrackActiveElm.style.width = `${percent}%`;
            }
        }
    }

    private onDragZoom(_: MouseEvent, data: DraggableData): void {
        if (this.sliderElm === null) {
            return;
        }
        const box = this.sliderElm.getBoundingClientRect();

        if (box.width <= 10) {
            return;
        }
        this.setZoom((data.x / (box.width - 10)), false);
    }

    private zoomOut(ev: MouseEvent): boolean {
        ev.preventDefault();
        const delta = (ev.shiftKey) ? 0.1 : 0.05;

        this.setZoom(this.state.x - delta, true);
        return false;
    }

    private zoomIn(ev: MouseEvent): boolean {
        ev.preventDefault();
        const delta = (ev.shiftKey) ? 0.1 : 0.05;

        this.setZoom(this.state.x + delta, true);
        return false;
    }

    private onSliderClick(ev: MouseEvent): void {
        const elem = (ev.target as HTMLElement);

        if (
            (this.sliderElm === null) ||
            (elem.hasAttribute('data-tip'))
        ) {
            return;
        }
        ev.preventDefault();
        ev.stopPropagation();
        const bound = this.sliderElm.getBoundingClientRect();

        this.setZoom(
            (
                (ev.clientX - bound.x) /
                bound.width
            ),
            true,
        );
    }

    private getTimelineDuration(): number {
        if (
            (typeof (this.props.playerProps.timelineDuration) === 'undefined') ||
            (this.props.playerProps.timelineDuration < 60) ||
            (this.props.playerProps.timelineDuration > 86400)
        ) {
            return 7200;
        }
        return Math.round(this.props.playerProps.timelineDuration);
    }

    private computeSecondsByPixel(viewport: number): number {
        if (
            (this.getTimelineDuration() <= 0) ||
            (viewport <= 0)
        ) {
            return 0;
        }
        return (this.getTimelineDuration() / viewport);
    }

    private recomputeMaxZoom(viewport: number): number {
        let maxPixelsPerSecond = this.props.playerProps.maxPixelsPerSecond;

        if (
            (typeof maxPixelsPerSecond === 'undefined') ||
            (maxPixelsPerSecond < 10) ||
            (maxPixelsPerSecond > 500)
        ) {
            maxPixelsPerSecond = 150;
        }

        const spp = this.computeSecondsByPixel(viewport);
        const sppMin = 1 / maxPixelsPerSecond;
        let max = 1;

        for (max = 1; max < 4000; max++) {
            if ((spp / max) <= sppMin) {
                break;
            }
        }
        return max;
    }
}
